import { render, staticRenderFns } from "./CertificationParties.vue?vue&type=template&id=c588705a"
import script from "./CertificationParties.vue?vue&type=script&lang=js"
export * from "./CertificationParties.vue?vue&type=script&lang=js"
import style0 from "./CertificationParties.vue?vue&type=style&index=0&id=c588705a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports